import * as React from "react";
import { useWizard } from '../../../Hooks/UseWizard';
import Modal, { ModalSize } from '../../../../misc/components/modal';
import { WizardActionTypes } from '../WizardTypings';
import { EnterMediaSerial } from './EnterMediaSerial';
import { CorrectionPreviewModal } from '../../CorrectionPreviewModal';
import { Correction, VisibleWizards } from '../../../Request/DcfRequestReducer';
import { Form } from "informed";

export interface MediaSerialCorrectionWizardProps {
    isVisible: boolean;
    onClose: () => void;
    onComplete: (corrections: Correction[]) => void;
}

export const MediaSerialCorrectionWizard = ({ isVisible, onClose, originalMediaSerial, onComplete }) => {
    const { currentState, dispatch } = useWizard();
    const [correctedMediaSerial, setCorrectedMediaSerial] = React.useState(originalMediaSerial);

    if (!isVisible) {
        return null;
    }

    let page = null;
    switch (currentState.page) {
        case 0:
            page = (
                <Form>
                    <EnterMediaSerial currentMediaSerial={originalMediaSerial}
                        onNext={(value) => {
                        setCorrectedMediaSerial("FF" + value);
                        dispatch(WizardActionTypes.Next);
                        }}
                    />
                </Form>
            );
            break;
        case 1:
            const valueWithoutPrefix = originalMediaSerial ? originalMediaSerial.replace(new RegExp("FF", 'g'), "") : originalMediaSerial;
            const correctedWithoutPrefix = correctedMediaSerial ? correctedMediaSerial.replace(new RegExp("FF", 'g'), "") : correctedMediaSerial;

            const corrections = [{
                sourceCorrection: VisibleWizards.MediaSerial,
                entity: "CoughSession",
                field: "MediaSerialNumber",
                oldValue: valueWithoutPrefix,
                newValue: correctedWithoutPrefix
            }];
            page = (
                <CorrectionPreviewModal
                    corrections={corrections}
                    miscCorrection={null}
                    onNext={() => onComplete(corrections)}
                    onPrev={() => dispatch(WizardActionTypes.Previous)}
                />
            );
            break;
        default:
            page = null;
    }

    return (
        <Modal show={true} header="Change Card Serial Number" size={ModalSize.Large} closeModalHandler={onClose}>
            {page}
        </Modal>
    );
}
